/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CallerRef,
  CreateDraftRequest,
  CreateTeamRequest,
  DraftRecord,
  MapString,
  MapTeamIdTeam,
  MapTeamIdTeamMembers,
  PaginatedResultDraftAndTeam,
  PaginatedResultTeam,
  Team,
  UpdateDraftRequest,
  UpdateTeamRequest,
  UsageBulkRequestRes,
  UsageRequestRes,
  ValidateMemberRemovalRequest,
  WrappedLeaseRes,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "teams";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description queries teams
   *
   * @tags CRUD/Teams
   * @name QueryTeams
   * @request GET:/v1/tenant/{tenantId}/team
   * @secure
   */
  queryTeams = (
    tenantId: string,
    query?: {
      /** @example "QA" */
      name?: string;
      /** @example "user/167a67d47a6da76d4a761" */
      createdBy?: string;
      /** @example "user/167a67d47a6da76d4a761" */
      updatedBy?: string;
      /** @example ["a5sd43a5d4a3da5d5ad45ad4asd"] */
      workspaceId?: string[];
      /** @example ["167a67d47a6da76d4a761"] */
      member?: string[];
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultTeam,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/team`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for queryTeams */
  queryTeamsPathGetter = (
    tenantId: string,
    query?: {
      /** @example "QA" */
      name?: string;
      /** @example "user/167a67d47a6da76d4a761" */
      createdBy?: string;
      /** @example "user/167a67d47a6da76d4a761" */
      updatedBy?: string;
      /** @example ["a5sd43a5d4a3da5d5ad45ad4asd"] */
      workspaceId?: string[];
      /** @example ["167a67d47a6da76d4a761"] */
      member?: string[];
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/team`, query);

  /**
   * @description creates a team
   *
   * @tags CRUD/Teams
   * @name CreateTeam
   * @request POST:/v1/tenant/{tenantId}/team
   * @secure
   */
  createTeam = (tenantId: string, data: CreateTeamRequest, params: RequestParams = {}) =>
    this.request<
      Team,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/team`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createTeam */
  createTeamPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/team`);

  /**
   * @description attempts to find team specified by the id
   *
   * @tags CRUD/Teams
   * @name GetTeam
   * @request GET:/v1/tenant/{tenantId}/team/{teamId}
   * @secure
   */
  getTeam = (
    tenantId: string,
    teamId: string,
    query?: {
      /**
       * if present will attempt to return historical version with specified revision, also returns deleted resources
       * @format int32
       */
      revision?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      Team,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/team/${teamId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getTeam */
  getTeamPathGetter = (
    tenantId: string,
    teamId: string,
    query?: {
      /**
       * if present will attempt to return historical version with specified revision, also returns deleted resources
       * @format int32
       */
      revision?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/team/${teamId}`, query);

  /**
   * @description updates team specified by the id
   *
   * @tags CRUD/Teams
   * @name UpdateTeam
   * @request POST:/v1/tenant/{tenantId}/team/{teamId}
   * @secure
   */
  updateTeam = (tenantId: string, teamId: string, data: UpdateTeamRequest, params: RequestParams = {}) =>
    this.request<
      Team,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/team/${teamId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateTeam */
  updateTeamPathGetter = (tenantId: string, teamId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/team/${teamId}`);

  /**
   * @description deletes team specified by the id
   *
   * @tags CRUD/Teams
   * @name DeleteTeam
   * @request DELETE:/v1/tenant/{tenantId}/team/{teamId}
   * @secure
   */
  deleteTeam = (
    tenantId: string,
    teamId: string,
    query?: {
      /**
       * whether rule should be deleted EVEN if there are resources using it
       * @default false
       * @example false
       */
      force?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      Team,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/team/${teamId}`,
      method: "DELETE",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteTeam */
  deleteTeamPathGetter = (
    tenantId: string,
    teamId: string,
    query?: {
      /**
       * whether rule should be deleted EVEN if there are resources using it
       * @default false
       * @example false
       */
      force?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/team/${teamId}`, query);

  /**
   * @description validates if removing members wouldn't leave a team empty
   *
   * @tags CRUD/Teams
   * @name ValidateMemberRemoval
   * @request POST:/v1/tenant/{tenantId}/teams/validate-member-removal
   * @secure
   */
  validateMemberRemoval = (tenantId: string, data: ValidateMemberRemovalRequest, params: RequestParams = {}) =>
    this.request<
      object,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/teams/validate-member-removal`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for validateMemberRemoval */
  validateMemberRemovalPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/teams/validate-member-removal`);

  /**
   * @description attempts to find teams specified by ids
   *
   * @tags CRUD/Teams
   * @name FindTeamsByIds
   * @request GET:/v1/tenant/{tenantId}/team-by-ids
   * @secure
   */
  findTeamsByIds = (
    tenantId: string,
    query?: {
      /**
       * @minItems 1
       * @example ["a5sd43a5d4a3da5d5ad45ad4asd","dasf567a34sd6as54fas67d5f4as"]
       */
      ids?: string[];
      /**
       * if set to `true` request will fail if at least one of the teams is missing
       * @default false
       */
      strict?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapTeamIdTeam,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/team-by-ids`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findTeamsByIds */
  findTeamsByIdsPathGetter = (
    tenantId: string,
    query?: {
      /**
       * @minItems 1
       * @example ["a5sd43a5d4a3da5d5ad45ad4asd","dasf567a34sd6as54fas67d5f4as"]
       */
      ids?: string[];
      /**
       * if set to `true` request will fail if at least one of the teams is missing
       * @default false
       */
      strict?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/team-by-ids`, query);

  /**
   * @description creates a team
   *
   * @tags CRUD/Team Drafts
   * @name CreateTeamDraft
   * @request POST:/v1/tenant/{tenantId}/draft
   * @secure
   */
  createTeamDraft = (tenantId: string, data: CreateDraftRequest, params: RequestParams = {}) =>
    this.request<
      DraftRecord,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/draft`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createTeamDraft */
  createTeamDraftPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/draft`);

  /**
   * @description attempts to find team specified by the id
   *
   * @tags CRUD/Team Drafts
   * @name GetTeamDraft
   * @request GET:/v1/tenant/{tenantId}/draft/{draftId}
   * @secure
   */
  getTeamDraft = (tenantId: string, draftId: string, params: RequestParams = {}) =>
    this.request<
      DraftRecord,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/draft/${draftId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getTeamDraft */
  getTeamDraftPathGetter = (tenantId: string, draftId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/draft/${draftId}`);

  /**
   * @description updates team specified by the id
   *
   * @tags CRUD/Team Drafts
   * @name UpdateTeamDraft
   * @request POST:/v1/tenant/{tenantId}/draft/{draftId}
   * @secure
   */
  updateTeamDraft = (tenantId: string, draftId: string, data: UpdateDraftRequest, params: RequestParams = {}) =>
    this.request<
      DraftRecord,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/draft/${draftId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateTeamDraft */
  updateTeamDraftPathGetter = (tenantId: string, draftId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/draft/${draftId}`);

  /**
   * @description deletes team specified by the id
   *
   * @tags CRUD/Team Drafts
   * @name DeleteTeamDraft
   * @request DELETE:/v1/tenant/{tenantId}/draft/{draftId}
   * @secure
   */
  deleteTeamDraft = (tenantId: string, draftId: string, params: RequestParams = {}) =>
    this.request<
      DraftRecord,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/draft/${draftId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteTeamDraft */
  deleteTeamDraftPathGetter = (tenantId: string, draftId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/draft/${draftId}`);

  /**
   * @description queries teams
   *
   * @tags CRUD/Team Queries
   * @name QueryTeamDrafts
   * @request GET:/v1/tenant/{tenantId}/team-and-draft
   * @secure
   */
  queryTeamDrafts = (
    tenantId: string,
    query?: {
      /** @example "QA" */
      name?: string;
      /** @example "user/167a67d47a6da76d4a761" */
      createdBy?: string;
      /** @example "user/167a67d47a6da76d4a761" */
      updatedBy?: string;
      /** @example ["a5sd43a5d4a3da5d5ad45ad4asd"] */
      workspaceId?: string[];
      /** @example ["167a67d47a6da76d4a761"] */
      member?: string[];
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultDraftAndTeam,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/team-and-draft`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for queryTeamDrafts */
  queryTeamDraftsPathGetter = (
    tenantId: string,
    query?: {
      /** @example "QA" */
      name?: string;
      /** @example "user/167a67d47a6da76d4a761" */
      createdBy?: string;
      /** @example "user/167a67d47a6da76d4a761" */
      updatedBy?: string;
      /** @example ["a5sd43a5d4a3da5d5ad45ad4asd"] */
      workspaceId?: string[];
      /** @example ["167a67d47a6da76d4a761"] */
      member?: string[];
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/team-and-draft`, query);

  /**
   * No description
   *
   * @tags CRUD/Team Queries
   * @name FindAllUsersInTeamsDuringTimePeriod
   * @request GET:/v1/tenant/{tenantId}/all-team-members-during-period
   * @secure
   */
  findAllUsersInTeamsDuringTimePeriod = (
    tenantId: string,
    query: {
      /**
       * list of team ids
       * @minItems 1
       */
      teamIds: string[];
      /**
       * start of the date range
       * @format date-time
       */
      since: string;
      /**
       * end of the date range
       * @format date-time
       */
      until?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapTeamIdTeamMembers,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/all-team-members-during-period`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAllUsersInTeamsDuringTimePeriod */
  findAllUsersInTeamsDuringTimePeriodPathGetter = (
    tenantId: string,
    query: {
      /**
       * list of team ids
       * @minItems 1
       */
      teamIds: string[];
      /**
       * start of the date range
       * @format date-time
       */
      since: string;
      /**
       * end of the date range
       * @format date-time
       */
      until?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/all-team-members-during-period`, query);

  /**
   * @description added as a alternative to the usages endpoint with GET method as not every http library support it
   *
   * @tags Lease
   * @name ListResourcesWhichUseThisResourceMethodPut
   * @request PUT:/v1/tenant/{tenantId}/lease
   * @secure
   */
  listResourcesWhichUseThisResourceMethodPut = (tenantId: string, data: UsageRequestRes, params: RequestParams = {}) =>
    this.request<
      WrappedLeaseRes[],
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUseThisResourceMethodPut */
  listResourcesWhichUseThisResourceMethodPutPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/lease`);

  /**
   * @description bulk PUT usages endpoint (GET method with body is not widely supported)
   *
   * @tags Lease
   * @name ListResourcesWhichUseQueriedResourcesMethodPut
   * @request PUT:/v1/tenant/{tenantId}/lease-by-ids
   * @secure
   */
  listResourcesWhichUseQueriedResourcesMethodPut = (
    tenantId: string,
    data: UsageBulkRequestRes,
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedLeaseRes[],
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease-by-ids`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUseQueriedResourcesMethodPut */
  listResourcesWhichUseQueriedResourcesMethodPutPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/lease-by-ids`);
}
